const NON_RENDERABLE_TYPES: string[] = ['tif','jp2','jpx','jpm','jxr','x-xbitmap','x-xbm','heif','heic','avif'];
export const isNonRenderable = (type: string): boolean => NON_RENDERABLE_TYPES.some(t => type.includes(t));
